import { Injectable, inject } from '@angular/core';
import { HttpTransportType, HubConnection, HubConnectionBuilder, LogLevel } from '@microsoft/signalr';

import { AuthService } from '../auth/auth.service';
import { HUB_BASE_URL } from '../config/api-config';

/**
 * Builds a configured HubConnection for a given hub path -- JWT attached via
 * accessTokenFactory (SignalR's mechanism for authenticating a WebSocket handshake,
 * since browsers cannot set an Authorization header on it), automatic reconnect, shared
 * across the three per-hub services in this folder.
 */
@Injectable({ providedIn: 'root' })
export class HubConnectionFactory {
  private readonly authService = inject(AuthService);
  private readonly hubBaseUrl = inject(HUB_BASE_URL);

  create(hubPath: string): HubConnection {
    return new HubConnectionBuilder()
      .withUrl(`${this.hubBaseUrl}${hubPath}`, {
        accessTokenFactory: () => this.authService.token() ?? '',
        transport: HttpTransportType.WebSockets,
      })
      .withAutomaticReconnect()
      .configureLogging(LogLevel.Warning)
      .build();
  }
}
